// extracted by mini-css-extract-plugin
export default {"middleContainer":"DashboardMiddleSection_middleContainer__uMeIc","postsContainer":"DashboardMiddleSection_postsContainer__wlSjK"};